import React, { Component } from "react";
import PropTypes from "prop-types";
import i18next from "i18next";
import PopupWrapper from "../PopupWrapper";
import ComplexParam from "../ComplexParam";
import paramRender from "../ParamRenderUniversal";

export class PopupEditor extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onSaveRow = () => {
        if (this.props.onSave)
            this.props.onSave();
    };

    onCancelEdit = () => {
        if (this.props.onCancel)
            this.props.onCancel();
    };

    render() {

        const self = this;

        if (!self.props.visible)
            return null;

        const renderButtons = function () {
            return (<div className="modal-footer text-right">
                <div className="text-right">
                    {!self.props.readOnly && <button className="btn btn-regular -goahead"
                            onClick={self.onSaveRow}>{self.props.saveButtonText || i18next.t('Save')}
                    </button>}
                    &nbsp;
                    <button className="btn btn-regular"
                            onClick={self.onCancelEdit}>{self.props.cancelButtonText || i18next.t('Cancel')}
                    </button>
                </div>
            </div>);
        };

        return (<PopupWrapper popupVisible title={self.props.title || i18next.t('Edit')}
                              onClose={self.onCancelEdit}
                              renderButtons={renderButtons} style={self.props.style} maxWidthBody={self.props.maxWidthBody}
                              usePortal={self.props.usePortal}>
            {self.props.children}
            <ComplexParam dataItem={self.props.dataItem} rootPath={self.props.rootStore}
                          renderParams={self.props.onParamRender}
                          rowIndex={self.props.rowIndex} overrideVisibility={self.props.overrideVisibilityEdit} readOnly={self.props.readOnly} />

        </PopupWrapper>);
    }
}

PopupEditor.propTypes = {
    dispatch: PropTypes.func,
    dataItem: PropTypes.object,
    rowIndex: PropTypes.number,
    visible: PropTypes.bool,
    readOnly: PropTypes.bool,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.string,
    saveButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string,
    onParamRender: PropTypes.func,
    usePortal: PropTypes.bool,
    style: PropTypes.object,
    maxWidthBody: PropTypes.string
};


PopupEditor.defaultProps = {
    rowIndex : 0,
    readOnly : true,
    onParamRender: paramRender,
    usePortal: true
};